import React, { Component } from 'react';
import './App.css';
import './screens/Tracking/Tracking.css';
import { BrowserRouter, Route } from 'react-router-dom';
import Drawer from '@material-ui/core/Drawer';

import Login from './screens/Login/Components/Login.js';
import Header from './screens/Header/Components/Header.js';
import SideMenu from './commons/SideMenu.js';
import UserInfo from './commons/UserInfo.js';
import LogoutBox from './commons/LogoutBox.js';

import Home from './screens/Home/Components/Home.js';
import WarehouseVisibility from './screens/WarehouseVisibility/Components/WarehouseVisibility.js';

import UserList from './screens/UserList/Components/UserList.js';

import PutawayJobs from './screens/JobOperations/Components/PutawayJobs.js';
import IWTJobs from './screens/JobOperations/Components/IWTJobs.js';
import PickJobs from './screens/JobOperations/Components/PickJobs.js';
import TransferJobs from './screens/JobOperations/Components/TransferJobs.js';
import SortingJobs from './screens/JobOperations/Components/SortingJobs.js';
import PutawayDashboard from './screens/JobOperations/Components/PutawayDashboard.js';
import IWTDashboard from './screens/JobOperations/Components/IWTDashboard.js';
import TransferDashboard from './screens/JobOperations/Components/TransferDashboard.js';

import VehicleMapping from './screens/DispatchJobs/Components/VehicleMapping.js';
import CrateSticker from './screens/DispatchJobs/Components/CrateSticker.js';
import StockTake from './screens/InventoryOperations/Components/StockTake.js';
//import StockCorrection from './screens/InventoryOperations/Components/StockCorrection.js';
import StockTransfer from './screens/InventoryOperations/Components/StockTransfer.js';
import IWTTransfer from './screens/InventoryOperations/Components/IWTTransfer.js';
//import RegenerateMissingItemIMR from './screens/InventoryOperations/Components/RegenerateMissingItemIMR.js';
import ChangeStatus from './screens/InventoryOperations/Components/ChangeStatus.js';

import GenerateSpace from './screens/SpaceOperations/Components/GenerateSpace.js';
import GeoMarker from './screens/SpaceOperations/Components/GeoMarker.js';
import Infrastructure from './screens/SpaceOperations/Components/Infrastructure.js';
import ProductAllocation from './screens/SpaceOperations/Components/ProductAllocation.js';
import ProductOnboard from './screens/SpaceOperations/Components/ProductOnboard.js';
import Space from './screens/SpaceOperations/Components/Space.js';
import BreakContingousSpace from './screens/SpaceOperations/Components/BreakContingousSpace.js';

import ZoneIngestion from './screens/DynamicSpaceAllocation/Components/ZoneIngestion.js';
import ProductInfraCapacityMapping from './screens/DynamicSpaceAllocation/Components/ProductInfraCapacityMapping.js';

import RequestLiquidation from './screens/Liquidation/Components/RequestLiquidation.js';
import CompleteLiquidation from './screens/Liquidation/Components/CompleteLiquidation.js';

import RequestPurchaseReturn from './screens/PurchaseReturn/Components/RequestPurchaseReturn.js';
import AcceptPurchaseReturn from './screens/PurchaseReturn/Components/AcceptPurchaseReturn.js';
import RejectPurchaseReturn from './screens/PurchaseReturn/Components/RejectPurchaseReturn.js';

import RequestQC from './screens/QC/Components/RequestQC.js';
import MarkQCFail from './screens/QC/Components/MarkQCFail.js';
import MarkQCPass from './screens/QC/Components/MarkQCPass.js';
import MarkQCDispatch from './screens/QC/Components/MarkQCDispatch.js';

import ViewDeliveryChallan from './screens/SellerReturns/Components/ViewDeliveryChallan.js';
import GenerateDeliveryChallan from './screens/SellerReturns/Components/GenerateDeliveryChallan.js';
import SellerReturnWindow from './screens/SellerReturns/Components/SellerReturnWindow.js';
import GoodsStatusUpdate from './screens/SellerReturns/Components/GoodsStatusUpdate.js';
import ReturnDispatch from './screens/SellerReturns/Components/ReturnDispatch.js';
import LiquidationDispatch from './screens/SellerReturns/Components/LiquidationDispatch.js';

import InvoiceControl from './screens/InvoiceControl/Components/InvoiceControl.js';

import Inwarding from './screens/Inwarding/Components/Inwarding.js';
import AddPallet from './screens/Inwarding/Components/Commons/AddPallet.js';
import ProductBarcodeMapper from './screens/Inwarding/Components/Commons/ProductBarcodeMapper.js';
import ProductDetails from './screens/Inwarding/Components/Commons/ProductDetails.js';
import InvoiceInward from './screens/Inwarding/Components/Commons/InvoiceInward.js';
//import InvoiceInward2 from './screens/Inwarding/Components/Commons/InvoiceInward2.js';
import AddMoreQuantity from './screens/Inwarding/Components/Commons/AddMoreQuantity.js';

import InwardingTest from './screens/InwardingTest/ComponentsTest/InwardingTest.js';
import AddPalletTest from './screens/InwardingTest/ComponentsTest/CommonsTest/AddPalletTest.js';
import ProductBarcodeMapperTest from './screens/InwardingTest/ComponentsTest/CommonsTest/ProductBarcodeMapperTest.js';
import ProductDetailsTest from './screens/InwardingTest/ComponentsTest/CommonsTest/ProductDetailsTest.js';
import InvoiceInwardTest from './screens/InwardingTest/ComponentsTest/CommonsTest/InvoiceInwardTest.js';
//import InvoiceInward2Test from './screens/InwardingTest/ComponentsTest/CommonsTest/InvoiceInward2Test.js';
import AddMoreQuantityTest from './screens/InwardingTest/ComponentsTest/CommonsTest/AddMoreQuantityTest.js';
import AddNewFreebieTest from './screens/InwardingTest/ComponentsTest/CommonsTest/AddNewFreebieTest';
import AddNewFreebie from './screens/Inwarding/Components/Commons/AddNewFreebie';
import FreebieDetailsTest from './screens/InwardingTest/ComponentsTest/CommonsTest/FreebieDetailsTest';
import FreebieDetails from './screens/Inwarding/Components/Commons/FreebieDetails';

import ReceivingFacilityMapping from './screens/SellerReceiving/Components/ReceivingFacilityMapping.js';
import APKs from './screens/APKs/Components/APKs.js';

import CONF from './config/config.js';

import { openobserveRum } from '@openobserve/browser-rum';
import { openobserveLogs } from '@openobserve/browser-logs';

import { Provider } from 'react-redux';
import store from './redux/store';
import TrackingScreen from './screens/Tracking/TrackingScreen';

var user = JSON.parse(localStorage.getItem('user'));
var allowNewCountingScreen = true;


/**
 * APM OpenO 
 * */
const options = {
    clientToken: '63643866336133622d363039332d343161632d613336352d653966373062613564363536',
    applicationId: 'BRADMAN',
    site: 'api.openobserve.ai',
    service: 'BRADMAN',
    env: 'production',
    version: '1.0.0',
    organizationIdentifier: 'vaibhav_pratap_organization_19960_VFqfuNKP5kiczTc',
    insecureHTTP: false,
    apiVersion: 'v1',
  };
  
  openobserveRum.init({
    applicationId: options.applicationId, // required, any string identifying your application
    clientToken: options.clientToken,
    site: options.site,
    organizationIdentifier: options.organizationIdentifier,
    service: options.service,
    env: options.env,
    version: options.version,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    apiVersion: options.apiVersion,
    insecureHTTP: options.insecureHTTP,
    defaultPrivacyLevel: 'allow' // 'allow' or 'mask-user-input' or 'mask'. Use one of the 3 values.
  });
  
  openobserveLogs.init({
    clientToken: options.clientToken,
    site: options.site,
    organizationIdentifier: options.organizationIdentifier,
    service: options.service,
    env: options.env,
    version: options.version,
    forwardErrorsToLogs: true,
    insecureHTTP: options.insecureHTTP,
    apiVersion: options.apiVersion,
  });

/** END */



class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openSideDrawer: false,
        };
        this.showSideMenu = this.showSideMenu.bind(this);
        this.toggleDrawer = this.toggleDrawer.bind(this);
        this.clickedButton = this.clickedButton.bind(this);
        this.clickedButton = this.clickedButton.bind(this);
    }

    componentDidMount() {
        var ct = document.getElementById('contents');
        if (ct) {
            var headerHeight = document.getElementById('header').offsetHeight;
            ct.style.height = 'calc(100vh - ' + headerHeight + 'px)';
            document.getElementById('sideBar').style.height =
                'calc(100vh - ' + headerHeight + 'px)';
        }
        if(user){ 
            openobserveRum.setUser({
                id: user.bradmanUserProfile.naturalId,
                name: user.bradmanUserProfile.displayName,
                email: user.bradmanUserProfile.emailId,
              });
        } else {
            openobserveRum.setUser({
                id: "0000",
                name: "DefaultUser",
                email: "deafult@jumbotail.com",
              }); 
        }
        openobserveRum.startSessionReplayRecording();

    }

    showSideMenu() {
        this.toggleDrawer();
    }

    clickedButton(e) {
        var a = e.target.innerHTML;
        if (a.indexOf('<i class="fas fa-chevron-') === -1) {
            this.toggleDrawer();
        }
    }
    toggleDrawer() {
        //if (this.state.openSideDrawer) {
        //    this.setState({ openSideDrawer: false })
        //} else {
        //    this.setState({ openSideDrawer: true })
        //}
        this.setState({ openSideDrawer: !this.state.openSideDrawer });
    }

    render() {
        return (
            <div>
                <BrowserRouter>
                    <Provider store={store}>
                        <div>
                            {!user ? (
                                <Login />
                            ) : (
                                <div>
                                    <div id="header">
                                        <Header
                                            showSideMenu={this.showSideMenu}
                                        />
                                    </div>
                                    <div className="row no-margin">
                                        <div
                                            className="col-md-2 logo-box no-padding hidden-xs hidden-sm"
                                            id="sideBar"
                                            style={{ overflow: 'auto' }}
                                        >
                                            <SideMenu />
                                        </div>
                                        <div
                                            className="col-md-10 header-box no-padding"
                                            id="contents"
                                            style={{ overflow: 'auto' }}
                                        >
                                            <Route
                                                exact
                                                path="/"
                                                component={Home}
                                            />

                                            <Route
                                                exact
                                                path="/WarehouseVisibility"
                                                component={WarehouseVisibility}
                                            />

                                            <Route
                                                exact
                                                path="/UserList"
                                                component={UserList}
                                            />

                                            <Route
                                                exact
                                                path="/PutawayJobs"
                                                component={PutawayJobs}
                                            />
                                            <Route
                                                exact
                                                path="/IWTJobs"
                                                component={IWTJobs}
                                            />
                                            <Route
                                                exact
                                                path="/PickJobs"
                                                component={PickJobs}
                                            />
                                            <Route
                                                exact
                                                path="/TransferJobs"
                                                component={TransferJobs}
                                            />
                                            <Route
                                                exact
                                                path="/SortingJobs"
                                                component={SortingJobs}
                                            />
                                            <Route
                                                exact
                                                path="/PutawayDashboard"
                                                component={PutawayDashboard}
                                            />
                                            <Route
                                                exact
                                                path="/IWTDashboard"
                                                component={IWTDashboard}
                                            />
                                            <Route
                                                exact
                                                path="/TransferDashboard"
                                                component={TransferDashboard}
                                            />

                                            <Route
                                                exact
                                                path="/VehicleMapping"
                                                component={VehicleMapping}
                                            />

                                            <Route
                                                exact
                                                path="/CrateSticker"
                                                component={CrateSticker}
                                            />

                                            <Route
                                                exact
                                                path="/StockTake"
                                                component={StockTake}
                                            />
                                            {
                                                //<Route exact path='/StockCorrection' component={StockCorrection}/>
                                            }
                                            <Route
                                                exact
                                                path="/StockTransfer"
                                                component={StockTransfer}
                                            />
                                            <Route
                                                exact
                                                path="/IWTTransfer"
                                                component={IWTTransfer}
                                            />
                                            <Route
                                                exact
                                                path="/Inwarding-ASN"
                                                component={TrackingScreen}
                                            />
                                            <Route
                                                exact
                                                path="/Inwarding-Putaway"
                                                component={TrackingScreen}
                                            />
                                            <Route
                                                exact
                                                path="/Inwarding-Contingency"
                                                component={TrackingScreen}
                                            />
                                            <Route
                                                exact
                                                path="/Sorting-Progress"
                                                component={TrackingScreen}
                                            />
                                            <Route
                                                exact
                                                path="/Picking-Progress"
                                                component={TrackingScreen}
                                            />
                                            <Route
                                                exact
                                                path="/Picking-Missing-Damages"
                                                component={TrackingScreen}
                                            />
                                            <Route
                                                exact
                                                path="/Stock-Take-Dump"
                                                component={TrackingScreen}
                                            />
                                            <Route
                                                exact
                                                path="/Returns-Tracking"
                                                component={TrackingScreen}
                                            />
                                            <Route
                                                exact
                                                path="/Warhouse-Capacities"
                                                component={TrackingScreen}
                                            />
                                            <Route
                                                exact
                                                path="/Operation-Tracking"
                                                component={TrackingScreen}
                                            />
                                            {
                                                //<Route exact path='/RegenerateMissingItemIMR' component={RegenerateMissingItemIMR}/>
                                            }
                                            <Route
                                                exact
                                                path="/ChangeStatus"
                                                component={ChangeStatus}
                                            />

                                            <Route
                                                exact
                                                path="/GenerateSpace"
                                                component={GenerateSpace}
                                            />
                                            <Route
                                                exact
                                                path="/Space"
                                                component={Space}
                                            />
                                            <Route
                                                exact
                                                path="/ProductAllocation"
                                                component={ProductAllocation}
                                            />
                                            <Route
                                                exact
                                                path="/GeoMarker"
                                                component={GeoMarker}
                                            />
                                            <Route
                                                exact
                                                path="/Infrastructure"
                                                component={Infrastructure}
                                            />
                                            <Route
                                                exact
                                                path="/ProductOnboard"
                                                component={ProductOnboard}
                                            />
                                            <Route
                                                exact
                                                path="/BreakContingousSpace"
                                                component={BreakContingousSpace}
                                            />

                                            <Route
                                                exact
                                                path="/DynamicSpaceAllocation/ZoneIngestion"
                                                component={
                                                    ZoneIngestion
                                                }
                                            />

                                            <Route
                                                exact
                                                path="/DynamicSpaceAllocation/ProductInfraCapacityMapping"
                                                component={
                                                    ProductInfraCapacityMapping
                                                }
                                            />

                                            <Route
                                                exact
                                                path="/RequestLiquidation"
                                                component={RequestLiquidation}
                                            />
                                            <Route
                                                exact
                                                path="/CompleteLiquidation"
                                                component={CompleteLiquidation}
                                            />

                                            <Route
                                                exact
                                                path="/RequestPurchaseReturn"
                                                component={
                                                    RequestPurchaseReturn
                                                }
                                            />
                                            <Route
                                                exact
                                                path="/AcceptPurchaseReturn"
                                                component={AcceptPurchaseReturn}
                                            />
                                            <Route
                                                exact
                                                path="/RejectPurchaseReturn"
                                                component={RejectPurchaseReturn}
                                            />

                                            <Route
                                                exact
                                                path="/RequestQC"
                                                component={RequestQC}
                                            />
                                            <Route
                                                exact
                                                path="/MarkQCFail"
                                                component={MarkQCFail}
                                            />
                                            <Route
                                                exact
                                                path="/MarkQCPass"
                                                component={MarkQCPass}
                                            />
                                            <Route
                                                exact
                                                path="/MarkQCDispatch"
                                                component={MarkQCDispatch}
                                            />

                                            <Route
                                                exact
                                                path="/ViewDeliveryChallan"
                                                component={ViewDeliveryChallan}
                                            />
                                            <Route
                                                exact
                                                path="/GenerateDeliveryChallan"
                                                component={
                                                    GenerateDeliveryChallan
                                                }
                                            />
                                            <Route
                                                exact
                                                path="/SellerReturnWindow"
                                                component={SellerReturnWindow}
                                            />
                                            <Route
                                                exact
                                                path="/GoodsStatusUpdate"
                                                component={GoodsStatusUpdate}
                                            />
                                            <Route
                                                exact
                                                path="/ReturnDispatch"
                                                component={ReturnDispatch}
                                            />
                                            <Route
                                                exact
                                                path="/LiquidationDispatch"
                                                component={LiquidationDispatch}
                                            />

                                            <Route
                                                exact
                                                path="/ReceivingFacilityMapping"
                                                component={
                                                    ReceivingFacilityMapping
                                                }
                                            />

                                            <Route
                                                exact
                                                path="/InvoiceControl"
                                                component={InvoiceControl}
                                            />

                                            <Route
                                                exact
                                                path="/APKs"
                                                component={APKs}
                                            />

                                            {allowNewCountingScreen ? (
                                                <React.Fragment>
                                                    <Route
                                                        exact
                                                        path="/Inwarding"
                                                        component={
                                                            InwardingTest
                                                        }
                                                    />
                                                    <Route
                                                        exact
                                                        path="/Inwarding/AddPallet/:vinv"
                                                        component={
                                                            AddPalletTest
                                                        }
                                                    />
                                                    <Route
                                                        exact
                                                        path="/Inwarding/BarcodeMapper"
                                                        component={
                                                            ProductBarcodeMapperTest
                                                        }
                                                    />
                                                    <Route
                                                        exact
                                                        path="/Inwarding/ProductDetails"
                                                        component={
                                                            ProductDetailsTest
                                                        }
                                                    />
                                                    <Route
                                                        exact
                                                        path="/Inwarding/Invoice"
                                                        component={
                                                            InvoiceInwardTest
                                                        }
                                                    />
                                                    {/* <Route exact path='/Inwarding/Invoice' component={InvoiceInward2Test} /> */}
                                                    <Route
                                                        exact
                                                        path="/Inwarding/Invoice/AddMoreQuantity"
                                                        component={
                                                            AddMoreQuantityTest
                                                        }
                                                    />
                                                    <Route
                                                        exact
                                                        path="/Inwarding/AddNewFreebie"
                                                        component={
                                                            AddNewFreebieTest
                                                        }
                                                    />
                                                    <Route
                                                        exact
                                                        path="/Inwarding/FreebieDetails"
                                                        component={
                                                            FreebieDetailsTest
                                                        }
                                                    />
                                                </React.Fragment>
                                            ) : (
                                                <React.Fragment>
                                                    <Route
                                                        exact
                                                        path="/Inwarding"
                                                        component={Inwarding}
                                                    />
                                                    <Route
                                                        exact
                                                        path="/Inwarding/AddPallet/:vinv"
                                                        component={AddPallet}
                                                    />
                                                    <Route
                                                        exact
                                                        path="/Inwarding/BarcodeMapper"
                                                        component={
                                                            ProductBarcodeMapper
                                                        }
                                                    />
                                                    <Route
                                                        exact
                                                        path="/Inwarding/ProductDetails"
                                                        component={
                                                            ProductDetails
                                                        }
                                                    />
                                                    <Route
                                                        exact
                                                        path="/Inwarding/Invoice"
                                                        component={
                                                            InvoiceInward
                                                        }
                                                    />
                                                    {/* <Route exact path='/Inwarding/Invoice' component={InvoiceInward2} /> */}
                                                    <Route
                                                        exact
                                                        path="/Inwarding/Invoice/AddMoreQuantity"
                                                        component={
                                                            AddMoreQuantity
                                                        }
                                                    />
                                                    <Route
                                                        exact
                                                        path="/Inwarding/AddNewFreebie"
                                                        component={
                                                            AddNewFreebie
                                                        }
                                                    />
                                                    <Route
                                                        exact
                                                        path="/Inwarding/FreebieDetails"
                                                        component={
                                                            FreebieDetails
                                                        }
                                                    />
                                                </React.Fragment>
                                            )}

                                            <div className="visible-xs visible-sm">
                                                <Drawer
                                                    open={
                                                        this.state
                                                            .openSideDrawer
                                                    }
                                                    onClose={this.toggleDrawer}
                                                    classes={{
                                                        paper: 'black-box',
                                                    }}
                                                >
                                                    <div
                                                        tabIndex={0}
                                                        role="button"
                                                        onClick={
                                                            this.clickedButton
                                                        }
                                                        onKeyDown={
                                                            this.toggleDrawer
                                                        }
                                                        style={{
                                                            height: '100vh',
                                                            backgroundColor:
                                                                '#212121',
                                                        }}
                                                    >
                                                        <UserInfo />
                                                        <SideMenu />
                                                        <div
                                                            style={{
                                                                padding:
                                                                    '0 17px 17px',
                                                            }}
                                                        >
                                                            <LogoutBox />
                                                        </div>
                                                    </div>
                                                </Drawer>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </Provider>
                </BrowserRouter>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js